import React, { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { TrackingProp } from 'react-tracking';
import { SEO } from 'components/SEO';
import AccountLayout from 'components/Layouts/AccountLayout';
import { analyticsWrapper } from '../../analytics/itly/analyticsWrapper';
import { useGoogleReCaptcha } from 'features/google-recaptcha';
import { getCustomAttribute } from 'helpers/mage-helpers/magento';
import { customerAddressesSelector, customerCustomAttributesSelector } from 'store/customer/selectors';
import { fetchCustomerRequest } from 'store/customer/actions';
import { RecentProjects } from 'components/MyAccount/RecentProjects';
import { RecentOrders } from 'components/MyAccount/RecentOrders';
import { AccountInformation } from 'components/MyAccount/AccountInformation';
import { AddressBook } from 'components/MyAccount/AddressBook';
import { MyAccountContent } from 'components/MyAccount/styled';
import { useAuthentication } from 'hooks/useAuthentication';
import { useTrackPageViewed } from 'analytics/itly/hooks';

const MyAccountPage = ({ tracking }: { tracking: TrackingProp }) => {
  useAuthentication();
  useTrackPageViewed(tracking, 'Account', 'Account Page');
  useGoogleReCaptcha({ pageType: 'Account', pageName: 'Account Page', action: 'account' });
  const dispatch = useDispatch();

  const customAttributes = useSelector(customerCustomAttributesSelector, shallowEqual);
  const addresses = useSelector(customerAddressesSelector);

  const flashId = getCustomAttribute('flash_id')(customAttributes);

  useEffect(() => {
    if (!flashId) {
      dispatch(fetchCustomerRequest());
    }
  }, [flashId, dispatch]);

  return (
    <AccountLayout tracking={tracking} hideSideMenuAt={1096}>
      <SEO title="My Account" />
      <MyAccountContent>
        <RecentProjects />
        <RecentOrders />
        <AccountInformation />
        <AddressBook addresses={addresses} />
      </MyAccountContent>
    </AccountLayout>
  );
};

export default analyticsWrapper(MyAccountPage);
